<template>
  <div class="acomodar">
      <Horario/>
  </div>
</template>

<script>

import Horario from '@/components/Nominas/Horario.vue';

export default {
  name: "HorariodeNomina",
  data() {
      return {};
  },
  mounted() {
  },

  created(){
      this.cambiarEstadoNavbar()
  },
  methods: {
      
  cambiarEstadoNavbar() {
    // Acción directa para cambiar el estado del navbar a true
    this.$store.dispatch('acciones/CambioNavbar', true);
  }

  },
  components: { Horario} 
};
</script>

<style scoped>
.acomodar {
box-shadow: rgba(22, 22, 22, 0.2) 0px 2px 8px 0px;
width: 100%;
margin-right: 0.5rem !important;
margin-top: 9px;
margin-bottom: 9px;
background: rgb(255, 255, 255);
min-height: 100vh;
overflow-x: auto;
overflow-y:hidden;
}
</style>
